/**
 * Whether demo mode is active for this session.
 *
 * Session flag, not a path check: the demo navigates away from /demo/* to the real
 * dashboard routes, but demo mode stays on. Kept dependency-free so app code can
 * import it without pulling in the demo runtime.
 */

let active = false;

export function markDemoMode(): void {
  active = true;
}

export function isDemoMode(): boolean {
  return active;
}
